module.exports = __webpack_public_path__ + "static/shopmatic2-323a7cb0bc57afaca3caeb183a9aab94.png";